<main class="container">
  <app-chat-container></app-chat-container>
  @if (isLoading) {
  <section id="column">
    <div class="row">
      <div class="col col-12">
        <app-applications-skeleton [showOwnerFilter]="isPlatformUser || isAMORETeam" [showAssignmentDate]="isAMORETeam"
          [showExcludedFilter]="strategystatus === 'Excluded'">
        </app-applications-skeleton>
      </div>
    </div>
  </section>
  }
  @if (!isLoading) {
  <section id="column">
    <div class="row">
      <div class="col col-12">
        <div class="d-flex align-items-center mb-3">
          <div class="flex-grow-1 flex-basis-0">
            <button class="btn btn-sm btn-outline-secondary btn-back" (click)="goToDashboard()">
              Back
            </button>
          </div>
          <h1 class="applications-title mb-0 text-center flex-shrink-0">Application Portfolio<br /><small>Manage
              modernization
              assessments for your applications</small></h1>
          <div class="flex-grow-1 flex-basis-0"></div>
        </div>

        <div class="d-flex align-items-end mb-2">
          @if (!isLoading && (isPlatformUser || isAMORETeam)) {
          <div class="form-group mr-3 mb-0">
            <label for="technicalOwnerFilter" class="form-label">Show Applications</label>
            <select id="technicalOwnerFilter" class="form-control filter-select" [(ngModel)]="assignedByOM"
              (change)="onTechnicalOwnerFilterChange()">
              <option [ngValue]="null">All Applications</option>
              <option [ngValue]="true">AMORE (ARM) Application</option>
              <option [ngValue]="false">My Applications (Owner)</option>
              @if (isAMORETeam) {
              <option [ngValue]="'showMyWork'">My Assigned Applications</option>
              }
            </select>
          </div>
          }

          @if (!isLoading && strategystatus === 'Excluded') {
          <div class="form-group mr-3 mb-0">
            <label for="showRejectedAppsFilter" class="form-label">Show Records</label>
            <select id="showRejectedAppsFilter" class="form-control filter-select" [(ngModel)]="showRejectedApps"
              (change)="onShowRejectedAppsFilterChange()">
              <option [ngValue]="null">All</option>
              <option [ngValue]="true">Rejected</option>
              <option [ngValue]="false">Excluded</option>
            </select>
          </div>
          }
        </div>

        @if (!isLoading && strategystatus === 'Excluded') {
        <p class="rejected-note">Note: Rejected applications are displayed with a strikethrough.</p>
        }

        <div class="data-grid-wrapper" [class.d-none]="isLoading">
          <app-data-grid [columns]="displayedColumns" [data]="applications.data" [actions]="gridActions"
            [config]="dataGridConfig" [totalCount]="totalItems" [columnGroups]="aiColumnGroups"
            [loading]="isGridLoading" [initialPageIndex]="page - 1" [initialColumnFilters]="columnFiltersMap"
            [filterOptions]="filterOptions" [filtersLoaded]="filtersLoaded" (pageChanged)="onPageChange($event)"
            (sortChanged)="onSortChange($event)" (columnFilterChanged)="onColumnFilterChange($event)">
          </app-data-grid>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- Custom cell templates -->
  <ng-template #actionTemplate let-row>
    <div class="action-btn-group" style="display: flex; gap: 8px;">
      <!-- Show status chip when assessment is Pending or Running -->
      @if (!row.modernizationAssessmentHasAiJob && !row.requiresManualReview && row.codeAnalysisStatus === 'Pending') {
      <span class="assessment-status-chip pending" title="Queued for processing (fair round-robin)">
        <mat-icon class="status-icon">hourglass_empty</mat-icon>
        Queued #{{ row.codeAnalysisQueuePosition || '?' }}
      </span>
      }
      @if (!row.modernizationAssessmentHasAiJob && !row.requiresManualReview && row.codeAnalysisStatus === 'Running') {
      <span class="assessment-status-chip running" title="Assessment is currently running">
        <mat-icon class="status-icon spin">sync</mat-icon>
        Running...
      </span>
      }
      @if (!row.modernizationAssessmentHasAiJob && !row.requiresManualReview && row.codeAnalysisStatus === 'Failed') {
      <span class="assessment-status-chip failed" [title]="row.codeAnalysisErrorMessage || 'Assessment failed'">
        <mat-icon class="status-icon">error_outline</mat-icon>
        Failed
      </span>
      }

      <button class="button small" (click)="onViewClick(row)">View Details</button>
    </div>
  </ng-template>

  <ng-template #cmdbValidationTemplate let-row>
    @if (row.cmdbValidationNeeded === 'Yes') {
      <span class="cmdb-validation-needed-badge" title="CMDB confidence is low. Review CMDB metadata.">CMDB Validation Needed</span>
    } @else {
      <span class="text-muted">—</span>
    }
  </ng-template>
</main>